import { Gift, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const ReferralBanner = () => {
  return (
    <section className="py-14 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl bg-gradient-hero p-8 md:p-12 text-primary-foreground"
        >
          {/* Decorative circles */}
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-primary-foreground/5" />
          <div className="absolute -bottom-6 -left-6 w-28 h-28 rounded-full bg-primary-foreground/5" />
          <div className="absolute top-1/2 right-1/4 w-20 h-20 rounded-full bg-primary-foreground/5" />

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-4">
                <Gift className="w-6 h-6" />
                <span className="text-sm font-semibold uppercase tracking-wider opacity-80">
                  Referral Program
                </span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold mb-3 leading-tight">
                Refer & Earn with Every Purchase
              </h2>
              <p className="text-sm opacity-80 max-w-lg leading-relaxed mb-6">
                Share your unique referral link with friends and family. Earn commission on every purchase they make. 
                Multi-level income structure – the more you share, the more you earn!
              </p>
              <div className="flex flex-wrap gap-3">
                <Button className="h-11 px-6 bg-card text-foreground hover:bg-card/90 font-heading font-semibold rounded-xl">
                  Start Referring <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
                <Button
                  className="h-11 px-6 border border-primary-foreground/30 bg-transparent text-primary-foreground hover:bg-primary-foreground/15 font-heading rounded-xl"
                >
                  Learn More
                </Button>
              </div>
            </div>

            <div className="flex gap-4 md:gap-6">
              {[
                { value: "₹50", label: "Per Referral" },
                { value: "5%", label: "Commission" },
                { value: "∞", label: "No Limits" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="text-center bg-primary-foreground/10 backdrop-blur-sm rounded-2xl px-5 py-4 border border-primary-foreground/10"
                >
                  <p className="font-heading text-2xl font-bold">{stat.value}</p>
                  <p className="text-[11px] opacity-70 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ReferralBanner;
